module.exports = '<svg width="37" height="32" viewBox="0 0 37 32"><path d="M0 20.789v-9.577c0-1.323.987-2.069 2.24-2.069h16.046V1.312c0-1.323.704-1.71 1.664-.864l15.913 14.018c.965.846.942 2.222-.018 3.067L19.966 31.551c-.967.846-1.68.459-1.68-.864v-7.831H2.24c-1.253 0-2.24-.745-2.24-2.069z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/right-arrow-2.js
// module id = 1384
// module chunks = 14